"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const framer_motion_1 = require("framer-motion");
const classnames_1 = __importDefault(require("classnames"));
const ChevronRightIcon_1 = __importDefault(require("../../icons/ChevronRightIcon"));
const useToggle_1 = __importDefault(require("../../hooks/useToggle"));
const navbar_module_scss_1 = __importDefault(require("./navbar.module.scss"));
const NavbarSublinks = ({ navLinkWrapper, title, links }) => {
    const [isOpen, { setTrue: handleOpen, setFalse: handleClose, toggle: handleClick }] = (0, useToggle_1.default)();
    return ((0, jsx_runtime_1.jsxs)("li", Object.assign({ className: (0, classnames_1.default)(navbar_module_scss_1.default.navbar_links_item, navbar_module_scss_1.default.navbar_links_sublinks), onMouseEnter: handleOpen, onMouseLeave: handleClose }, { children: [(0, jsx_runtime_1.jsxs)("button", Object.assign({ type: "button", className: navbar_module_scss_1.default.navbar_links_sublinks_button, onClick: handleClick }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: navbar_module_scss_1.default.navbar_links_sublinks_title }, { children: title }), void 0), (0, jsx_runtime_1.jsx)(ChevronRightIcon_1.default, { className: (0, classnames_1.default)(navbar_module_scss_1.default.navbar_links_sublinks_icon, {
                            [navbar_module_scss_1.default.navbar_links_sublinks_icon_active]: isOpen
                        }) }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(framer_motion_1.AnimatePresence, { children: isOpen && ((0, jsx_runtime_1.jsx)(framer_motion_1.motion.ul, Object.assign({ className: navbar_module_scss_1.default.navbar_links_sublinks_items }, sublinksAnimations, { children: links.map((subLink, index) => {
                        return ((0, jsx_runtime_1.jsx)("li", Object.assign({ className: (0, classnames_1.default)(navbar_module_scss_1.default.navbar_links_item, navbar_module_scss_1.default.navbar_links_sublinks_item) }, { children: navLinkWrapper
                                ? navLinkWrapper(Object.assign(Object.assign({}, subLink), { activeClassName: navbar_module_scss_1.default.navbar_link_active, className: navbar_module_scss_1.default.navbar_link }))
                                : subLink.text }), index));
                    }) }), void 0)) }, void 0)] }), void 0));
};
exports.default = NavbarSublinks;
const sublinksAnimations = {
    initial: 'hidden',
    animate: 'visible',
    exit: 'hidden',
    variants: {
        hidden: {
            opacity: 0,
            y: -10
        },
        visible: {
            opacity: 1,
            y: 0
        }
    },
    transition: {
        ease: 'easeOut',
        duration: 0.2
    }
};
